export default "__VITE_PUBLIC_ASSET__a356741c__"